import { render, staticRenderFns } from "./ITRForeignBankAccountCard.vue?vue&type=template&id=22d0450c&scoped=true&"
import script from "./ITRForeignBankAccountCard.vue?vue&type=script&lang=ts&"
export * from "./ITRForeignBankAccountCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d0450c",
  null
  
)

export default component.exports